/**
 * Header V2 Configuration Constants
 */
export const HEADER_V2_CONFIG = {
  /**
   * The maximum number of top-level categories displayed horizontally in the desktop navigation bar.
   */
  MAX_DESKTOP_CATEGORIES: 8,

  /**
   * The category list index at which the dropdown panel starts aligning its right edge to the trigger
   * rather than the left edge (to prevent right-hand viewport clipping).
   */
  ALIGN_RIGHT_INDEX_THRESHOLD: 4,
};
